import { styled } from "@acko-tech/building-blocks.ui.common";

export const MainContainer = styled.div`
  width: 100%;
  color: #040222;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.1px;
  z-index: 1;

  ${(props) => props.styles}
  span {
    color: #7c47e1;
  }
  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 28px;
    width: 100%;
    ${(props) => props.mStyles}
`;

export const SubHeading = styled.div`
    color: var(--Neutral-N600, #040222);

    /* Paragraph/Small */
    font-family: "Euclid Circular B";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    margin-right: 8px;
`;

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
`;

export const MainHeadingBottomText = styled.div`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const SubHeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: -webkit-fill-available;
  gap: 2px;
  background-color: var(--background-secondary-n-50, #F8F7FC);
  padding: 12px;
  border-radius: 12px;
  justify-content: space-between;
`;

export const SubHeadingBottomText = styled.div`
  color: var(--Neutral-N500, #36354C);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const MainHeadingWrapper = styled.div`
  margin-bottom: 16px;
`;
